/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { useAuth } from '@vaas/react-ui-kit/auth';

/**
 * Single gate for internal-only metadata (program code, engineering/build release). Dealer partner
 * claims mark external users; everyone else is treated as internal.
 *
 * <p>The last thing read from the token besides identity. It answers which company someone works
 * for, which no amount of granting inside this application can change; what they may do here is
 * the database's to say.
 */
export function useIsInternalUser(): boolean {
  const { account } = useAuth();
  // Until the account resolves we can't confirm the user is internal; default to external so
  // internal-only metadata (program code / engineering release) is never exposed during loading.
  if (!account) return false;
  const partnerType = (account as { partnerType?: string }).partnerType;
  return !partnerType?.trim();
}

/** External (dealer partner) user; false until the account resolves, like {@link useIsInternalUser}. */
export function useIsDealerUser(): boolean {
  const { account } = useAuth();
  const internal = useIsInternalUser();
  return Boolean(account) && !internal;
}
